"use strict";

function _interopRequireDefault(o) {
  return o && o.__esModule ? o : {
    default: o
  };
}
function _objectWithoutProperties(o, e) {
  var r = {};
  for (var t in o) e.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
  return r;
}
function make(o, e) {
  var r = e.left,
    t = e.right,
    p = e.mirror,
    n = e.opposite,
    a = (r ? 1 : 0) | (t ? 2 : 0) | (p ? 16 : 0) | (n ? 32 : 0) | (o ? 64 : 0);
  if (lookup.hasOwnProperty(a)) return lookup[a];
  if (!p != !(o && n)) {
    var i = [t, r];
    r = i[0], t = i[1];
  }
  var l = r ? "-100%" : t ? "100%" : "0",
    u = o ? "from {\n        opacity: 1;\n      }\n      to {\n        transform: translate3d(" + l + ", 0, 0) skewX(30deg);\n        opacity: 0;\n      }\n    " : "from {\n        transform: translate3d(" + l + ", 0, 0) skewX(-30deg);\n        opacity: 0;\n      }\n      60% {\n        transform: skewX(20deg);\n        opacity: 1;\n      }\n      80% {\n        transform: skewX(-5deg);\n        opacity: 1;\n      }\n      to {\n        transform: none;\n        opacity: 1;\n      }";
  return lookup[a] = (0, _globals.animation)(u), lookup[a];
}
function LightSpeed() {
  var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _globals.defaults,
    e = o.children,
    r = (o.out, o.forever),
    t = o.timeout,
    p = o.duration,
    n = void 0 === p ? _globals.defaults.duration : p,
    a = o.delay,
    i = void 0 === a ? _globals.defaults.delay : a,
    l = o.count,
    u = void 0 === l ? _globals.defaults.count : l,
    s = _objectWithoutProperties(o, ["children", "out", "forever", "timeout", "duration", "delay", "count"]),
    d = {
      make: make,
      duration: void 0 === t ? n : t,
      delay: i,
      forever: r,
      count: u,
      style: {
        animationFillMode: "both"
      }
    };
  s.left, s.right, s.mirror, s.opposite;
  return (0, _wrap2.default)(s, d, d, e);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _wrap = require("./wrap"),
  _wrap2 = _interopRequireDefault(_wrap),
  _propTypes = require("prop-types"),
  _globals = require("./globals"),
  propTypes = {
    out: _propTypes.bool,
    left: _propTypes.bool,
    right: _propTypes.bool,
    mirror: _propTypes.bool,
    opposite: _propTypes.bool,
    duration: _propTypes.number,
    timeout: _propTypes.number,
    delay: _propTypes.number,
    count: _propTypes.number,
    forever: _propTypes.bool
  },
  lookup = {};
LightSpeed.propTypes = propTypes, exports.default = LightSpeed, module.exports = exports.default;